import { render, staticRenderFns } from "./SubcardUser.vue?vue&type=template&id=d54c3fcc&"
import script from "./SubcardUser.vue?vue&type=script&lang=js&"
export * from "./SubcardUser.vue?vue&type=script&lang=js&"
import style0 from "./SubcardUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports